import { createContext } from "react";

export const InsideGalleryContext = createContext(false);
